export default __webpack_public_path__ + "static/169-bd311d49e59d38b7158a1cdceda65460.jpg";